export default __webpack_public_path__ + "images/52321e4750ce4981973174849478117b-thrive.svg";